import { render, staticRenderFns } from "./dataDetailModal.vue?vue&type=template&id=682ef987&scoped=true"
import script from "./dataDetailModal.vue?vue&type=script&lang=js"
export * from "./dataDetailModal.vue?vue&type=script&lang=js"
import style0 from "./dataDetailModal.vue?vue&type=style&index=0&id=682ef987&prod&lang=scss&scoped=true"
import style1 from "./dataDetailModal.vue?vue&type=style&index=1&id=682ef987&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682ef987",
  null
  
)

export default component.exports